
<svg viewBox="0 0 112 112">
  <path
    d="M105.341 58.236 9.549 111.47c-1.106.625-2.056.697-2.85.216-.793-.48-1.19-1.346-1.19-2.596V2.91c0-1.25.397-2.115 1.19-2.596.794-.481 1.744-.41 2.85.216l95.792 53.234c1.106.625 1.659 1.37 1.659 2.236 0 .866-.553 1.611-1.659 2.236z"
    fill="currentColor"
    fill-rule="nonzero"
  />
</svg>
